/**
 *  _    ___   ___  ___  ___
 * | |  | _ ) / _ \| _ \/ __|
 * | |__| _ \| (_) |   / (_ |
 * |____|___(_)___/|_|_\\___|
 *       Loadbalancer.org API
 * @copyright Copyright (c) 2017
 */
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-concertina-content',
    template: `
        <ng-template>
            <ng-content></ng-content>
        </ng-template>
    `,
})

export class ConcertinaContentComponent {
    /**
     * Reference to the content of this component.
     */
    @ViewChild(TemplateRef, { static: true }) public template: TemplateRef<any>;

    /**
     * State of an item.
     */
    @Input() public active = false;

    /**
     * Index of an item.
     */
    @Input() public index: number;

    /**
     * Title of an item.
     */
    @Input() public title: string;
}
